import React, { Component, Fragment } from "react"
import { Tooltip } from "reactstrap"
import { Link } from "react-router-dom"
import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/master/templateSuratService.jsx'
import DataTableBloc from '../Blocs/DataTableBloc'
import moment from "moment"

class TablePrimaryComponent extends Component {
    dataTableBloc = new DataTableBloc()

    source
    historyTable = 'historyTemplateSuratTable'
    defaultOrder = 'id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            loadingTable: true,
            rows: [],
            totalRow: 0,
            confirm: false,
            loading: false,
            success: false,
            failed: false,
            defaultSize: 10,
            deleteUuid: null,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    loadData = async () => {
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }

        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order
        }

        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel()
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.deleteData()
                break
            case 'success':
                forState = {
                    success: false
                }
                this.setTokenAPI()
                break
            case 'failed':
                forState = {
                    failed: false
                }
                break
            default:
        }
        this.setState(forState)
    }

    deleteData = async () => {
        await this.dataTableBloc.fetchDelete({ uuid: this.state.deleteUuid }, this.source.token)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.deleteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    })
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true
                    })
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.dataTableBloc.deleteChannel.unsubscribe()
    }

    columns = [
        {
            key: "template_surat_name",
            text: "Nama Template",
            className: "template_surat_name",
            sortable: true,
            width: '30%'
        },
        {
            key: "template_surat_create_date",
            text: "Tanggal Dibuat",
            className: "template_surat_create_date",
            sortable: true,
            width: '30%',
            cell: record => {
                return record.template_surat_create_date ? moment(record.template_surat_create_date).format('DD-MM-YYYY') : '-'
            }
        },
        {
            key: "document_type_name",
            text: "Jenis Surat",
            className: "document_type_name",
            sortable: true,
            width: '30%'
        },
        {
            key: "template_surat_file_path",
            text: "Template Surat",
            className: "template_surat_file_path",
            sortable: false,
            width: '20%',
            cell: record => {
                return (
                    <Fragment>
                        {record.template_surat_file_path ? (
                            <a href={record.template_surat_file_path} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-info">
                                <i className="uil-download-alt"></i> Download
                            </a>
                        ) : (
                            <span className="text-muted">-</span>
                        )}
                    </Fragment>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: '20%',
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.id
                return (
                    <Fragment>
                        {accessRole('view') && (
                            <Link to={`?template-surat=detail&uuid=${record.template_surat_uuid}`} className="btn btn-primary btn-sm" style={{ marginRight: '2px', padding: '2px 5px' }}>
                                <i className="uil-eye"></i>
                            </Link>
                        )}
                        {accessRole('update') && (
                            <Link to={`?template-surat=update&uuid=${record.template_surat_uuid}`} className="btn btn-warning btn-sm" style={{ marginRight: '2px', padding: '2px 5px' }}>
                                <i className="uil-pen"></i>
                            </Link>
                        )}
                        {accessRole('delete') && (
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => {
                                    this.setState({
                                        deleteUuid: record.template_surat_uuid,
                                        confirm: true
                                    })
                                }}
                                style={{ padding: '2px 5px' }}
                            >
                                <i className="uil-trash-alt"></i>
                            </button>
                        )}
                    </Fragment>
                )
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        })
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </>
        )
    }
}

export default TablePrimaryComponent

